<!-- Popup Header -->
<div class="d-flex popup-head align-items-center">
    <div class="popup-title mr-auto d-flex" translate>lblErrorLogEndpointDetails</div>
    <div class="float-right">
        <a class="close mr-2" href="javascript:void(0);" (click)="OnClose()" [attr.aria-label]="'lblClose' | translate">
            <span aria-hidden="true">&times;</span>
        </a>
    </div>
</div>

<!-- Body Header -->
<div class="subheader with-padding flgrow">
    <div class="row align-items-center">
        <div class="col-lg-6 col-md-6 col-sm-6">
            <input class="form-control" type="text" [value]="controllerName + ' / ' + methodName" disabled
                [attr.aria-label]="'lblController' | translate" />
        </div>
        <div class="col-lg-3 col-md-3 col-sm-6">
            <input class="form-control" type="text" disabled [attr.aria-label]="'lblBookedDateRange' | translate"
                [value]="(dateRange[0] | date : 'dd/MM/yyyy') + ' - ' + (dateRange[1] | date : 'dd/MM/yyyy')" />
        </div>
        <a class="ml-3 btn btn-outline-primary" href="javascript:void(0);" (click)="loadAll()" aria-label="Refresh">
            <em class="fas fa-sync fa-lg"></em>
        </a>
    </div>
</div>

<div class="scrollbar user">
    <div class="row">
        <div class="c12">
            <!-- Current output: latest spike of the endpoint -->
            <div class="card mb-3">
                <div class="card-header">
                    <span class="report-title" translate>lblCurrentOutput</span>
                </div>
                <div class="card-body" *ngIf="latest; else noOutput">
                    <div class="row">
                        <div class="col-lg-3 col-md-6 mb-3">
                            <label translate>lblWindowStart</label>
                            <div class="lbl-info">{{ toLocalDate(latest.windowStart) | date : 'dd.MM.yyyy, HH:mm' }}</div>
                        </div>
                        <div class="col-lg-3 col-md-6 mb-3">
                            <label translate>lblOccurrences</label>
                            <div class="lbl-info fontbold">{{ latest.occurrenceCount }}</div>
                        </div>
                        <div class="col-lg-3 col-md-6 mb-3">
                            <label translate>lblStatus</label>
                            <div class="lbl-info">
                                <app-error-log-status-editor [item]="latest" [editable]="true" (saved)="onStatusSaved()"></app-error-log-status-editor>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <label translate>lblWhyIssueOccurred</label>
                            <div class="lbl-info">{{ getCauseText(latest.cause) }}</div>
                        </div>
                        <div class="col-lg-6 mb-3">
                            <label translate>lblProbableSolution</label>
                            <div class="lbl-info solution-text">{{ latest.probableSolution }}</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-6 mb-3">
                            <label translate>lblErrorMessage</label>
                            <pre class="detail-pre">{{ latest.errorMessage }}</pre>
                        </div>
                        <div class="col-lg-6 mb-3" *ngIf="getThrownAt(latest.cause)">
                            <label translate>lblThrownAt</label>
                            <pre class="detail-pre">{{ getThrownAt(latest.cause) }}</pre>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <label translate>lblParameterPattern</label>
                            <div class="lbl-info">
                                <span class="status-chip mr-2" [class.status-chip-warning]="latest.isSameParameter"
                                    [class.status-chip-danger]="!latest.isSameParameter">
                                    <span>{{ (latest.isSameParameter ? 'lblSameParameter' : 'lblDifferentParameters') | translate }}</span>
                                    <span *ngIf="!latest.isSameParameter">({{ latest.distinctParamCount }})</span>
                                </span>
                                {{ latest.parameterPattern }}
                            </div>
                        </div>
                    </div>
                </div>
                <ng-template #noOutput>
                    <div class="card-body no-data" translate>lblNoRecordsFound</div>
                </ng-template>
            </div>

            <!-- All occurrences in the date range -->
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between align-items-center flex-wrap">
                    <span class="report-title" translate>lblAllOccurrences</span>
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{ occurrenceTotal }}
                        &nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h357" infinite-scroll [infiniteScrollDistance]="2"
                    [infiniteScrollThrottle]="50" [scrollWindow]="false" (scrolled)="onOccurrencesScrolled()">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 40px" scope="col"></th>
                                <th scope="col" translate>lblDateTime</th>
                                <th scope="col" translate>lblMethodType</th>
                                <th scope="col" translate>lblErrorMessage</th>
                                <th scope="col" translate>lblRequest</th>
                                <th scope="col" translate>lblStatus</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let occ of occurrences; trackBy: trackById">
                                <tr class="click-row" (click)="toggleOccurrence(occ.id)">
                                    <td>
                                        <em class="fas fa-chevron-right expand-ico" [class.is-open]="openOccurrenceId === occ.id"></em>
                                    </td>
                                    <td class="text-nowrap">{{ toLocalDate(occ.createdDate) | date : 'dd.MM.yyyy, HH:mm:ss' }}</td>
                                    <td>{{ occ.methodType }}</td>
                                    <td class="cell-text">{{ occ.errorMessage }}</td>
                                    <td class="request-cell"><pre class="request-pre">{{ formatJson(occ.paramDetails) || '-' }}</pre></td>
                                    <td class="text-nowrap">
                                        <span class="error-status {{ getStatus(occ.status).css }}">
                                            <span class="error-status-text">{{ getStatus(occ.status).text | translate }}</span>
                                        </span>
                                    </td>
                                </tr>
                                <tr class="detail-row" *ngIf="openOccurrenceId === occ.id">
                                    <td></td>
                                    <td colspan="5">
                                        <div class="row">
                                            <div class="col-lg-6">
                                                <div class="detail-block">
                                                    <div class="detail-title" translate>lblRequest</div>
                                                    <pre class="detail-pre">{{ formatJson(occ.paramDetails) || '-' }}</pre>
                                                </div>
                                                <div class="detail-block" *ngIf="occ.innerException">
                                                    <div class="detail-title" translate>lblInnerException</div>
                                                    <pre class="detail-pre">{{ occ.innerException }}</pre>
                                                </div>
                                            </div>
                                            <div class="col-lg-6">
                                                <div class="detail-block">
                                                    <div class="detail-title" translate>lblStackTrace</div>
                                                    <pre class="detail-pre">{{ occ.stackTrace || '-' }}</pre>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                            <tr *ngIf="occurrenceLoading">
                                <td colspan="6" class="no-record"><em class="fas fa-spinner fa-spin"></em></td>
                            </tr>
                            <tr *ngIf="!occurrenceLoading && occurrences.length === 0">
                                <td colspan="6" class="no-record" translate>lblNoRecordsFound</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Footer -->
<div class="p-3 bg-light pp-footer-top-brdr">
    <div class="row">
        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
            <a (click)="OnClose()" href="javascript:void(0);" class="btn btn-secondary btn-lg" translate><em
                    class="far fa-times-circle font16 align-top mr-2"></em>lblClose</a>
        </div>
    </div>
</div>
